<template>
  <div class="wrap">
    <div class="nav">
      <div class="game-logo"></div>
      <img
        src="../assets/img/nav/logo.png"
        alt=""
        srcset=""
        class="game-logo"
      />

      <div class="menu">
        <nav>
          <ul class="header-nav_list">
            <li
              class="header-nav_item"
              v-for="item in navlist"
              :key="item.id"
              @click="handleNav(item.id)"
              :class="menuPointer ? 'pEvents' : 'pEventsAuto'"
            >
              <img :src="activeIndex == item.id ? item.activeUrl : item.url" />
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="blog">
      <div class="share-icon" :class="arrowFlag ? 'bgShow' : 'bgHide'">
        <div class="iconarrow" @click="handleIconArrow()"></div>
        <div class="b-icon">
          <img
            v-for="idx in 3"
            :key="idx"
            :src="require('../assets/img/layer1/c-' + (idx + 1) + '.png')"
            alt=""
            srcset=""
            @click="handleIcon(idx + 1)"
          />
        </div>
      </div>
      <div class="bui-t" :class="buiFlag ? 'bgShow' : 'bgHide'">
        <img
          src="../assets/img/layer1/bui.png"
          alt=""
          srcset=""
          class="bui cursor"
          @click="goReg()"
        />
        <div class="buiarrow" @click="handleBuiArrow()"></div>
      </div>
    </div>
    <div class="page">
      <swiper
        :options="swiperOption"
        ref="goodSwiper"
        @slideChange="slideChange"
      >
        <swiper-slide>
          <layer1 @goReg="goReg()" />
        </swiper-slide>
        <!-- ref="layer2" -->
        <swiper-slide>
          <layer2
            @changeSilderDisable="changeSilderDisable"
            @changeSilderEnable="changeSilderEnable"
          />
        </swiper-slide>
        <swiper-slide>
          <layer3 ref="layer3" />
        </swiper-slide>
        <swiper-slide>
          <layer4 />
        </swiper-slide>
        <swiper-slide>
          <layer5 />
        </swiper-slide>
        <swiper-slide>
          <layer6 />
        </swiper-slide>
        <swiper-slide id="copyright">
          <copyright />
        </swiper-slide>
      </swiper>
    </div>
    <!-- 首页视频 -->
    <!-- <div
      v-if="videoFlag"
      class="model position-fixed"
      @click="videoFlag = false"
    >
      <div class="v-txt">
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/Nri41--d8rc?si=pSyVcPDGBs9YMq9w"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div> -->
  </div>
</template>

<script>
import layer1 from "./publicComponents/layer1";
import layer2 from "./publicComponents/layer2";
import layer3 from "./publicComponents/layer3";
import layer4 from "./publicComponents/layer4";
import layer5 from "./publicComponents/layer5";
import layer6 from "./publicComponents/layer6";

import copyright from "./publicComponents/copyright";

let _y = 0;
let _isEnd = false;

export default {
  components: {
    layer1,
    layer2,
    layer3,
    layer4,
    layer5,
    layer6,
    copyright
  },
  data() {
    return {
      arrowFlag: true,
      buiFlag: true,
      // videoFlag: false,
      // swiper
      nextShow: true,
      swiperOption: {
        direction: "vertical",
        slidesPerView: "auto",
        allowTouchMove: false,
        slideToClickedSlide: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        mousewheel: true, //开启鼠标
        noSwiping: false,
        noSwipingClass: "stop-swiping",
        initialSlide: 0,
        breakpoints: {
          780: {
            allowTouchMove: true
          }
        }
      },
      // menu
      navlist: [
        {
          id: 1,
          url: require("../assets/img/nav/1.png"),
          activeUrl: require("../assets/img/nav/1-active.png")
        },
        {
          id: 2,
          url: require("../assets/img/nav/2.png"),
          activeUrl: require("../assets/img/nav/2-active.png")
        },
        {
          id: 3,
          url: require("../assets/img/nav/3.png"),
          activeUrl: require("../assets/img/nav/3-active.png")
        },
        {
          id: 4,
          url: require("../assets/img/nav/4.png"),
          activeUrl: require("../assets/img/nav/4-active.png")
        },
        {
          id: 5,
          url: require("../assets/img/nav/5.png"),
          activeUrl: require("../assets/img/nav/5-active.png")
        },
        {
          id: 6,
          url: require("../assets/img/nav/6.png"),
          activeUrl: require("../assets/img/nav/6-active.png")
        }
      ],
      activeIndex: 1,
      menuPointer: false
    };
  },
  created() {},
  updated() {},

  mouthed() {},
  watch: {},
  computed: {},
  methods: {
    handleIcon(val) {
      if (val == 2) {
        this.common.goShare("yt");
      } else if (val == 3) {
        this.common.goShare("fb");
      } else if (val == 4) {
        this.common.goShare("dc");
      }
    },
    // 点击隐藏右边icon
    handleIconArrow() {
      this.arrowFlag = !this.arrowFlag;
    },
    handleBuiArrow() {
      this.buiFlag = !this.buiFlag;
    },
    // 预注册错误弹出框出来后，禁止页面滑动
    changeSilderDisable() {
      this.menuPointer = true;
      this.$refs.goodSwiper.swiper.mousewheel.disable();
    },
    changeSilderEnable() {
      this.menuPointer = false;
      this.$refs.goodSwiper.swiper.mousewheel.enable();
    },
    // 点击跳转到预注册页面
    goReg() {
      this.$refs.goodSwiper.swiper.slideTo(1, 300);
    },
    // 菜单
    handleNav(val) {
      this.activeIndex = val;
      const hcon = this.$refs.goodSwiper.swiper;
      if (val == 1) {
        hcon.slideTo(0, 300);
      }
      if (val == 2) {
        hcon.slideTo(1, 300);
      }
      if (val == 3) {
        hcon.slideTo(2, 300);
      }
      if (val == 4) {
        hcon.slideTo(3, 300);
      }
      if (val == 5) {
        hcon.slideTo(4, 300);
      }
      if (val == 6) {
        hcon.slideTo(5, 300);
      }
    },

    slideChange() {
      const mainActiveIndex = this.$refs.goodSwiper.swiper.activeIndex;
      this.activeIndex = mainActiveIndex + 1;
      if (mainActiveIndex == 2) {
        this.initData();
      }
    },

    // info 接口获取数据
    initData() {
      const reqTime = Math.floor(new Date().getTime() / 1000);
      let url = window.location.search;
      let preview = "unknow";
      let previewParam =
        url.indexOf("preview") >= 0
          ? this.common.getUrlParam("preview")
          : this.common.getUrlParam("preview");
      preview = previewParam || "unknow";

      this.$axios({
        method: "post",
        url: "braveheart/info",
        data: {
          //get这里应为params
          //请求参数
          signature: this.common.makeSignature({}, reqTime),
          reqTime: reqTime,
          // preview: this.common.getUrlParam("preview") || 0, // 测试数据
          preview: preview
        },
        //withCredentials:true, //局部携带cookie
        headers: {} //如果需要添加请求头可在这写
      })
        .then(res => {
          if (res.data.code === 0) {
            this.$refs.layer3.preview = res.data.data.register;
          }
        })
        .catch(err => {
          //请求失败就会捕获报错信息
          //err.response可拿到服务器返回的报错数据
        });
    }
    // 点击返回顶部
    // handleTop() {
    //   this.$refs.goodSwiper.swiper.slideTo(0, 300);
    // }
  }
};
</script>
<style lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #000;
  .pEvents {
    pointer-events: none;
  }
  .pEventsAuto {
    pointer-events: auto;
  }
  #copyright {
    height: 190px;
    width: 100%;
  }

  // 轮播

  .page {
    .swiper-container {
      width: 100%;
      height: 100%;
    }
  }

  .blog {
    position: absolute;
    right: 0;
    top: 2vw;
    display: flex;
    align-items: end;
    flex-direction: column;
    gap: 2vw;
    z-index: 1;
    .share-icon {
      background-image: url("../assets/img/layer1/share-bg.png");
      width: 291px;
      height: 86px;
      position: relative;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      .iconarrow {
        width: 49px;
        height: 100%;
      }
      .b-icon {
        width: calc(100% - 50px);
        height: 100%;
        position: absolute;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: .8vw;
        img {
          width: 50px;
          height: auto;
        }
      }
    }
    .bui-t {
      width: 339px;
      height: 222px;

      position: relative;
      .buiarrow {
        width: 75px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .bui {
        width: 100%;
        height: auto;
      }
    }
  }
  .bgShow {
    transition: all 0.3s;
  }
  .bgHide {
    transition: all 0.3s;
    margin-right: -13.9vw ;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainIndex.vue